// Centralized "session expired" handling.
//
// When any API call comes back 401 (the JWT expired or is invalid), we quietly
// sign the user out and send them to the login screen with a gentle notice —
// never a raw error toast. Covers both axios (see config/api.js interceptors)
// and window.fetch (installFetchAuthGuard, wired in index.js).

let redirecting = false;

// Auth endpoints must NOT trigger the redirect — a wrong password on the login
// form legitimately returns 401 and the form should show its own message.
const isAuthUrl = (url = '') =>
  /\/api\/auth\/(login|register|forgot-password|reset-password|verify-reset-token)/.test(url || '');

export function handleSessionExpired(url = '') {
  if (redirecting) return;                                   // one redirect per expiry
  if (isAuthUrl(url)) return;                                // let the login form handle it
  if (typeof window === 'undefined') return;
  if (window.location.pathname.startsWith('/login')) return; // already on login
  redirecting = true;
  try { localStorage.removeItem('token'); } catch (_) { /* ignore */ }
  window.location.href = '/login?expired=1';
}

// Wrap window.fetch once so fetch-based screens get the same treatment as axios.
export function installFetchAuthGuard() {
  if (typeof window === 'undefined' || window.__authFetchGuardInstalled) return;
  const orig = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await orig(...args);
    if (res && res.status === 401) {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      handleSessionExpired(url);
    }
    return res;
  };
  window.__authFetchGuardInstalled = true;
}
